import { DisplayField, GuestProfile, Membership } from '@mews-commander/guest-profile';
import { Optional } from '@mews/std';
import { getKeyByDisplayField } from './enumToKeyMap';

interface GetFieldValueProps {
    fieldName: DisplayField;
    profile: GuestProfile;
}

export const getFieldValue = ({ profile, fieldName }: GetFieldValueProps): Optional<string> => {
    const valueKey = getKeyByDisplayField(fieldName);

    if (fieldName === DisplayField.LoyaltyMembership) {
        return (profile[valueKey] as Membership)?.id ?? null;
    }
    return profile[valueKey] as Optional<string>;
};
